var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.569,
    height: 18.569,
    viewBox: "0 0 18.569 18.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clock-five",
    d: "M9.285,0a9.285,9.285,0,1,0,9.285,9.285A9.295,9.295,0,0,0,9.285,0Zm1.934,12.635a.774.774,0,0,1-1.057-.283L8.615,9.671a.771.771,0,0,1-.1-.387V4.642a.774.774,0,1,1,1.547,0V9.077l1.444,2.5a.774.774,0,0,1-.283,1.057Z",
    fill: "#4caa4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.96dae8e16c21b7bd87c4d09627de004b.svg";
export { ForwardRef as ReactComponent };